import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { trackInfraCumulativeLayoutShiftView } from "@faire/web-api--source/events/infra/view/cumulativeLayoutShift";
import { trackInfraFirstContentfulPaintView } from "@faire/web-api--source/events/infra/view/firstContentfulPaint";
import { trackInfraInteractionToNextPaintView } from "@faire/web-api--source/events/infra/view/interactionToNextPaint";
import { trackInfraLargestContentfulPaintView } from "@faire/web-api--source/events/infra/view/largestContentfulPaint";
import once from "lodash/once";
import { useCallback, useEffect, useRef, useState, useLayoutEffect } from "react";
// eslint-disable-next-line @faire-react/no-restricted-imports
import { onCLS, onLCP, onFCP, onINP } from "web-vitals/attribution";
import { getDocumentOrThrow } from "../../globals/getDocument";
import { HistoryTiming } from "../HistoryTiming";
var clsListeners = new Set();
var latestClsReport = null;
var lcpListeners = new Set();
var latestLcpReport = null;
var fcpListeners = new Set();
var latestFcpReport = null;
var inpListeners = new Set();
var latestInpReport = null;
// Make resetINP accessible outside startListening
var resetINP;
var resetCLS;
var startListening = once(function () {
  // This is a one-way ticket. Once you start listening, you can't stop.
  // So, no matter how many reporters we have, we want to use the same
  // listener.
  resetCLS = onCLS(function (report) {
    latestClsReport = report;
    var _iterator = _createForOfIteratorHelper(clsListeners),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var listener = _step.value;
        listener(report);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, {
    reportAllChanges: true
  });
  onLCP(function (report) {
    latestLcpReport = report;
    var _iterator2 = _createForOfIteratorHelper(lcpListeners),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var listener = _step2.value;
        listener(report);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }, {
    reportAllChanges: true
  });
  onFCP(function (report) {
    latestFcpReport = report;
    var _iterator3 = _createForOfIteratorHelper(fcpListeners),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var listener = _step3.value;
        listener(report);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }, {
    reportAllChanges: true
  });
  resetINP = onINP(function (report) {
    latestInpReport = report;
    var _iterator4 = _createForOfIteratorHelper(inpListeners),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var listener = _step4.value;
        listener(report);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }, {
    reportAllChanges: true
  });
});
/**
 * Record the Cumulative Layout Shift (CLS) metric in Chromium browsers if the associated PETE event is of type DIRECT_LOAD.
 *
 * Please note that as of 2021, Chromium changed the definition of CLS to cap the aggregation
 * to the worst "window" of shifts. See https://web.dev/articles/cls-web-tooling. This prevents
 * it from being used to track layout shifts across soft navigations.
 *
 * This means that CLS, as implemented in Chromium, cannot be used to track layout shifts
 * for soft (client-side) navigation as of May 2024, however the Chromium team is working on
 * a solution. See https://developer.chrome.com/docs/web-platform/soft-navigations-experiment
 *
 * CLS increases over time, so we wait as late as possible to report the value. Specifically,
 * we report it when the visibility state is changed to hidden (which can be when the tab
 * is hidden or closed), or when the component unmounts. CLS can be reported multiple times
 * for a single page view.
 *
 * CLS is only supported in Chromium browsers. No events will be triggered in browsers where CLS is not supported.
 *
 * If `isAction` is true, this is not a direct load and nothing will be reported.
 */
export var useTrackCumulativeLayoutShift = function useTrackCumulativeLayoutShift(name, loadType) {
  var _getWindow$Performanc, _getWindow, _getWindow$Performanc2;
  var _useState = useState(latestClsReport),
    _useState2 = _slicedToArray(_useState, 2),
    cls = _useState2[0],
    setCls = _useState2[1];
  var latestCls = useRef(cls);
  latestCls.current = cls;
  var supportsCLS = (_getWindow$Performanc = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow$Performanc2 = _getWindow.PerformanceObserver) === null || _getWindow$Performanc2 === void 0 ? void 0 : _getWindow$Performanc2.supportedEntryTypes.includes("layout-shift")) !== null && _getWindow$Performanc !== void 0 ? _getWindow$Performanc : false;
  useEffect(function () {
    clsListeners.add(setCls);
    startListening();
    return function () {
      clsListeners.delete(setCls);
    };
  }, [setCls]);
  var reportCLS = useCallback(function () {
    var _latestCls$current;
    if (loadType && supportsCLS && ((_latestCls$current = latestCls.current) === null || _latestCls$current === void 0 ? void 0 : _latestCls$current.value) !== undefined && latestCls.current.attribution.loadState === "complete") {
      var _latestCls$current2, _latestCls$current3, _latestCls$current4, _latestCls$current5;
      trackInfraCumulativeLayoutShiftView(name, loadType, String(latestCls.current.value), JSON.stringify({
        largestShiftTarget: String((_latestCls$current2 = latestCls.current) === null || _latestCls$current2 === void 0 ? void 0 : _latestCls$current2.attribution.largestShiftTarget),
        largestShiftTime: Number((_latestCls$current3 = latestCls.current) === null || _latestCls$current3 === void 0 ? void 0 : _latestCls$current3.attribution.largestShiftTime),
        largestShiftValue: Number((_latestCls$current4 = latestCls.current) === null || _latestCls$current4 === void 0 ? void 0 : _latestCls$current4.attribution.largestShiftValue),
        loadState: (_latestCls$current5 = latestCls.current) === null || _latestCls$current5 === void 0 ? void 0 : _latestCls$current5.attribution.loadState
      }));
    }
  }, [supportsCLS, loadType, name]);
  useLayoutEffect(function () {
    var _resetCLS;
    (_resetCLS = resetCLS) === null || _resetCLS === void 0 ? void 0 : _resetCLS();
  }, []);
  var handleVisibilityChange = useCallback(function () {
    if (getDocumentOrThrow().visibilityState === "hidden") {
      reportCLS();
    }
  }, [reportCLS]);
  // Report CLS when visibility changes (including on close), and when the component unmounts.
  useEffect(function () {
    addEventListener("visibilitychange", handleVisibilityChange);
    return function () {
      removeEventListener("visibilitychange", handleVisibilityChange);
      reportCLS();
    };
  }, [reportCLS, handleVisibilityChange]);
  return cls;
};
export var useTrackFirstContentfulPaint = function useTrackFirstContentfulPaint(name, isAction) {
  var _useState3 = useState(latestFcpReport),
    _useState4 = _slicedToArray(_useState3, 2),
    fcp = _useState4[0],
    setFcp = _useState4[1];
  var latestFcp = useRef(fcp);
  latestFcp.current = fcp;
  // Whether this event will be recorded as a DIRECT_LOAD.
  var isDirectLoad = useRef(HistoryTiming.get().isInitialLoad).current && !isAction;
  var reportFcp = useCallback(function (fcp) {
    if (isDirectLoad && (fcp === null || fcp === void 0 ? void 0 : fcp.attribution.loadState) === "complete") {
      var _fcp$value;
      trackInfraFirstContentfulPaintView(name,
      // This is provided for consistency. FCP only applies to direct loads.
      "DIRECT_LOAD", String((_fcp$value = fcp === null || fcp === void 0 ? void 0 : fcp.value) !== null && _fcp$value !== void 0 ? _fcp$value : 0), JSON.stringify({
        firstByteToFCP: String(fcp === null || fcp === void 0 ? void 0 : fcp.attribution.firstByteToFCP),
        loadState: Number(fcp === null || fcp === void 0 ? void 0 : fcp.attribution.loadState),
        timeToFirstByte: Number(fcp === null || fcp === void 0 ? void 0 : fcp.attribution.timeToFirstByte)
      }));
    }
  }, [isDirectLoad, name]);
  useEffect(function () {
    fcpListeners.add(setFcp);
    fcpListeners.add(reportFcp);
    if (latestFcp.current) {
      reportFcp(latestFcp.current);
    }
    startListening();
    return function () {
      fcpListeners.delete(setFcp);
      fcpListeners.delete(reportFcp);
    };
  }, [reportFcp, setFcp]);
  return fcp;
};
export var useTrackLargestContentfulPaint = function useTrackLargestContentfulPaint(name, isAction) {
  var _getWindow$Performanc3, _getWindow2, _getWindow2$Performan;
  var _useState5 = useState(latestLcpReport),
    _useState6 = _slicedToArray(_useState5, 2),
    lcp = _useState6[0],
    setLcp = _useState6[1];
  var latestLcp = useRef(lcp);
  latestLcp.current = lcp;
  // Whether this event will be recorded as a DIRECT_LOAD.
  var isDirectLoad = useRef(HistoryTiming.get().isInitialLoad).current && !isAction;
  var supportsLCP = (_getWindow$Performanc3 = (_getWindow2 = getWindow()) === null || _getWindow2 === void 0 ? void 0 : (_getWindow2$Performan = _getWindow2.PerformanceObserver) === null || _getWindow2$Performan === void 0 ? void 0 : _getWindow2$Performan.supportedEntryTypes.includes("largest-contentful-paint")) !== null && _getWindow$Performanc3 !== void 0 ? _getWindow$Performanc3 : false;
  useEffect(function () {
    lcpListeners.add(setLcp);
    startListening();
    return function () {
      lcpListeners.delete(setLcp);
    };
  }, [setLcp]);
  var reportLCP = useCallback(function () {
    if (supportsLCP && isDirectLoad) {
      var _latestLcp$current$va, _latestLcp$current, _latestLcp$current2, _latestLcp$current3, _latestLcp$current4;
      trackInfraLargestContentfulPaintView(name,
      // This is provided for consistency. LCP only applies to direct loads.
      "DIRECT_LOAD", String((_latestLcp$current$va = (_latestLcp$current = latestLcp.current) === null || _latestLcp$current === void 0 ? void 0 : _latestLcp$current.value) !== null && _latestLcp$current$va !== void 0 ? _latestLcp$current$va : 0), JSON.stringify({
        element: String((_latestLcp$current2 = latestLcp.current) === null || _latestLcp$current2 === void 0 ? void 0 : _latestLcp$current2.attribution.element),
        resourceLoadTime: Number((_latestLcp$current3 = latestLcp.current) === null || _latestLcp$current3 === void 0 ? void 0 : _latestLcp$current3.attribution.resourceLoadDuration),
        elementRenderDelay: Number((_latestLcp$current4 = latestLcp.current) === null || _latestLcp$current4 === void 0 ? void 0 : _latestLcp$current4.attribution.elementRenderDelay)
      }));
    }
  }, [supportsLCP, isDirectLoad, name]);
  var handleVisibilityChange = useCallback(function () {
    if (getDocumentOrThrow().visibilityState === "hidden") {
      reportLCP();
    }
  }, [reportLCP]);
  // Report LCP when visibility changes (including on close), and when the component unmounts.
  useEffect(function () {
    addEventListener("visibilitychange", handleVisibilityChange);
    return function () {
      removeEventListener("visibilitychange", handleVisibilityChange);
      reportLCP();
    };
  }, [reportLCP, handleVisibilityChange]);
  return lcp;
};
export var useTrackInteractionToNextPaint = function useTrackInteractionToNextPaint(name, loadType) {
  var _useState7 = useState(latestInpReport),
    _useState8 = _slicedToArray(_useState7, 2),
    inp = _useState8[0],
    setInp = _useState8[1];
  var latestInp = useRef(inp);
  latestInp.current = inp;
  useEffect(function () {
    inpListeners.add(setInp);
    startListening();
    return function () {
      inpListeners.delete(setInp);
    };
  }, [setInp]);
  var reportINP = useCallback(function () {
    var _latestInp$current;
    if (loadType && ((_latestInp$current = latestInp.current) === null || _latestInp$current === void 0 ? void 0 : _latestInp$current.value) !== undefined && latestInp.current.value > 0) {
      var _latestInp$current2, _latestInp$current$at, _latestInp$current3, _latestInp$current$at2, _latestInp$current4, _latestInp$current$at3, _latestInp$current5, _latestInp$current$at4, _latestInp$current6, _latestInp$current7;
      trackInfraInteractionToNextPaintView(name, loadType, String(latestInp.current.value), JSON.stringify({
        element: String(getElementDebugInfo((_latestInp$current2 = latestInp.current) === null || _latestInp$current2 === void 0 ? void 0 : _latestInp$current2.attribution.interactionTargetElement)),
        processingDuration: Math.round((_latestInp$current$at = (_latestInp$current3 = latestInp.current) === null || _latestInp$current3 === void 0 ? void 0 : _latestInp$current3.attribution.processingDuration) !== null && _latestInp$current$at !== void 0 ? _latestInp$current$at : 0),
        presentationDelay: Math.round((_latestInp$current$at2 = (_latestInp$current4 = latestInp.current) === null || _latestInp$current4 === void 0 ? void 0 : _latestInp$current4.attribution.presentationDelay) !== null && _latestInp$current$at2 !== void 0 ? _latestInp$current$at2 : 0),
        nextPaintTime: Math.round((_latestInp$current$at3 = (_latestInp$current5 = latestInp.current) === null || _latestInp$current5 === void 0 ? void 0 : _latestInp$current5.attribution.nextPaintTime) !== null && _latestInp$current$at3 !== void 0 ? _latestInp$current$at3 : 0),
        interactionTime: Math.round((_latestInp$current$at4 = (_latestInp$current6 = latestInp.current) === null || _latestInp$current6 === void 0 ? void 0 : _latestInp$current6.attribution.interactionTime) !== null && _latestInp$current$at4 !== void 0 ? _latestInp$current$at4 : 0),
        interactionType: (_latestInp$current7 = latestInp.current) === null || _latestInp$current7 === void 0 ? void 0 : _latestInp$current7.attribution.interactionType
      }));
    }
  }, [name, loadType]);
  useLayoutEffect(function () {
    var _resetINP;
    (_resetINP = resetINP) === null || _resetINP === void 0 ? void 0 : _resetINP();
  }, []);
  var handleVisibilityChange = useCallback(function () {
    if (getDocumentOrThrow().visibilityState === "hidden") {
      reportINP();
    }
  }, [reportINP]);
  // Report INP when visibility changes (including on close), and when the component unmounts.
  useEffect(function () {
    addEventListener("visibilitychange", handleVisibilityChange);
    return function () {
      removeEventListener("visibilitychange", handleVisibilityChange);
      reportINP();
    };
  }, [reportINP, handleVisibilityChange]);
  return inp;
};
/**
 * Convert an HTML Node to a concise string for logging, prioritizing data-test-id.
 * Keeps output under 255 characters for storage limitations.
 *
 * @param node - The HTML Node to convert to a string.
 * @returns A concise string representation of the HTML Node.
 */
function getElementDebugInfo(node) {
  if (!node || node.nodeType !== Node.ELEMENT_NODE) {
    return null;
  }
  var element = node;
  var tagName = element.tagName.toLowerCase();
  // Prioritize data-test-id if available
  var dataTestId = element.getAttribute("data-test-id");
  if (dataTestId) {
    return "".concat(tagName, "[").concat(dataTestId, "]");
  }
  // Fall back to id if available
  if (element.id) {
    return "".concat(tagName, "#").concat(element.id);
  }
  // Last resort: tag name with dimensions
  return "".concat(tagName, "[").concat(element.clientWidth, "x").concat(element.clientHeight, "]");
}